module.exports = __webpack_public_path__ + "resources/img/img_moai_cooperation_func.d2f7909ee46016c73199925a2b793136.png";